import { render, staticRenderFns } from "./inc_person_step_2.vue?vue&type=template&id=a307bf36&"
import script from "./inc_person_step_2.vue?vue&type=script&lang=js&"
export * from "./inc_person_step_2.vue?vue&type=script&lang=js&"
import style0 from "./inc_person_step_2.vue?vue&type=style&index=0&id=a307bf36&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports